import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Use when injecting HTML (e.g. in [innerHTML]) that is sure to be safe only.
 */
@Pipe({
    standalone: false,
    name: 'safeHtmlBypass'
})
export class SafeHtmlBypassPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(html: string) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
